<template>
  <section class="app-modal__section payment-plan-pay-modal__section--billing-data payment-plan-pay-modal__section--billing-data-compact">
    <header class="payment-plan-pay-modal__section-head">
      <h5>{{ text.payModal.billingData.title }}</h5>
    </header>

    <div v-if="showReceiverSelector" class="app-modal-field">
      <span>{{ text.payModal.billingData.fields.selector }}</span>
      <multiselect
        v-model="selectedReceiverModel"
        :options="receiverOptions"
        track-by="value"
        label="label"
        :custom-label="customerSearchLabel"
        :show-labels="false"
        :searchable="true"
        :allow-empty="false"
        :placeholder="text.payModal.billingData.placeholders.selector"
        class="app-modal-select"
      >
        <template #option="{ option }">
          <div class="expense-supplier-option">
            <small><strong>{{ billingDataText.modal.taxIdentifierLabels.national }}:</strong> {{ option?.meta?.rfc || '-' }}</small>
            <small><strong>{{ billingDataText.modal.form.fiscalIdentification.fields.fiscalName }}:</strong> {{ option?.meta?.businessName || '-' }}</small>
            <small><strong>{{ text.payModal.billingData.fields.customer }}:</strong> {{ option?.meta?.clientName || '-' }}</small>
          </div>
        </template>
        <template #singleLabel="{ option }">
          <div class="expense-supplier-option payment-plan-pay-modal__receiver-single">
            <span>{{ option?.meta?.businessName || option?.label || '' }}</span>
          </div>
        </template>
        <template #noResult>
          <span>{{ text.payModal.billingData.emptyOption }}</span>
        </template>
        <template #noOptions>
          <span>{{ text.payModal.billingData.emptyOption }}</span>
        </template>
      </multiselect>
    </div>

    <div class="payment-plan-pay-modal__billing-preview">
      <template v-if="selectedReceiver">
        <button
          type="button"
          class="app-table-icon-btn app-table-icon-btn--edit payment-plan-pay-modal__billing-preview-edit-btn"
          :title="billingDataText.card.actions.edit"
          @click="$emit('open-contributor')"
        >
          <i class="fa fa-pencil" aria-hidden="true"></i>
        </button>

        <div class="payment-plan-pay-modal__billing-preview-grid">
          <div class="payment-plan-pay-modal__billing-kv">
            <span>{{ text.payModal.billingData.fields.customer }}</span>
            <strong>{{ selectedReceiver?.meta?.clientName || selectedReceiver?.clientName || '-' }}</strong>
          </div>

          <div class="payment-plan-pay-modal__billing-kv">
            <span>{{ billingDataText.modal.taxIdentifierLabels.national }}</span>
            <strong>{{ selectedReceiver?.meta?.rfc || selectedReceiver?.rfc || '-' }}</strong>
          </div>

          <div class="payment-plan-pay-modal__billing-kv">
            <span>{{ billingDataText.modal.form.fiscalIdentification.fields.fiscalName }}</span>
            <strong>{{ selectedReceiver?.meta?.businessName || selectedReceiver?.businessName || '-' }}</strong>
          </div>

          <div class="payment-plan-pay-modal__billing-kv">
            <span>{{ text.payModal.billingData.fields.taxRegime }}</span>
            <strong>{{ selectedReceiver?.meta?.taxRegime || selectedReceiver?.taxRegime || '-' }}</strong>
          </div>

          <div class="payment-plan-pay-modal__billing-kv">
            <span>{{ billingDataText.modal.form.fiscalConfiguration.fields.cfdiUse }}</span>
            <strong>{{ selectedReceiver?.meta?.cfdiUse || selectedReceiver?.cfdiUse || '-' }}</strong>
          </div>

          <div class="payment-plan-pay-modal__billing-kv">
            <span>{{ billingDataText.modal.form.fiscalIdentification.fields.fiscalZipCode }}</span>
            <strong>{{ selectedReceiver?.meta?.fiscalResidence || selectedReceiver?.fiscalResidence || '-' }}</strong>
          </div>
        </div>
      </template>
      <span v-else>{{ text.payModal.billingData.emptyState }}</span>
    </div>
  </section>
</template>

<script>
export default {
  name: 'PayModalSectionBillingData',
  emits: ['update:selectedReceiver', 'open-contributor'],
  props: {
    text: {
      type: Object,
      required: true,
    },
    billingDataText: {
      type: Object,
      required: true,
    },
    receiverOptions: {
      type: Array,
      default: () => [],
    },
    selectedReceiver: {
      type: Object,
      default: null,
    },
    customerSearchLabel: {
      type: Function,
      required: true,
    },
  },
  computed: {
    showReceiverSelector() {
      return Array.isArray(this.receiverOptions) && this.receiverOptions.length > 1;
    },
    selectedReceiverModel: {
      get() {
        return this.selectedReceiver;
      },
      set(value) {
        this.$emit('update:selectedReceiver', value || null);
      },
    },
  },
};
</script>
